package sarka.design.skoria.network

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.websocket.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

/**
 * The browser handles TLS and certificate validation, so there is nothing to
 * configure here. URLs come from [ServerConfig] in common code.
 */
actual fun createPlatformHttpClient(): HttpClient =
    HttpClient(Js) {
        install(WebSockets)
        install(ContentNegotiation) {
            json(Json {
                prettyPrint = false
                isLenient = true
                ignoreUnknownKeys = true
            })
        }
        install(HttpTimeout) {
            requestTimeoutMillis = 10_000
            connectTimeoutMillis = 5_000
        }
    }
